<template>
  <div class="detail-follow">
    <!-- 收入 -->
    <div class="follow-input">
      <el-avatar :size="56" :src="`${$fileBaseUrl}/56x56/${user.userLogo}`">
        <img :src="`${$ssoUrl}/images/user/logo.png`" />
      </el-avatar>
      <div class="input-follow">
        <!-- 选项 -->
        <div class="operation">
          <span class="label">联系人</span>
          <el-select class="type" v-model="linkId" clearable placeholder="请选择联系人" @visible-change="visibleLinks">
            <el-option v-for="item in linkUserList" :key="item.id" :label="item.linkName" :value="item.id"> </el-option>
          </el-select>
          <span class="label">跟进方式</span>
          <el-select class="type" v-model="contactTypeId" clearable placeholder="请选择跟进方式">
            <el-option v-for="item in contactTypeOptions" :key="item.id" :label="item.description" :value="item.id"> </el-option>
          </el-select>
          <span class="label">下次跟进时间</span>
          <el-date-picker class="date-time" v-model="nextFollowupDate" clearable type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择下次跟进时间"></el-date-picker>
          <el-button type="primary" class="submit-btn" @click="addFollowLog">提交</el-button>
        </div>

        <el-form :model="form" :rules="rules" ref="ruleFormRef">
          <el-form-item label="" prop="followupContent">
            <el-input v-model="form.followupContent" type="textarea" rows="2" placeholder="请输入跟进内容" maxLength="200"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 列表 -->
    <div class="follow-list">
      <div class="follow-wrap">
        <div class="follow-item" v-for="rec in records" :key="rec.id">
          <div class="date-wrap">
            <div class="day">{{ rec.day }}</div>
            <div class="date">{{ rec.date }}</div>
          </div>
          <el-avatar :size="40" :src="`${$fileBaseUrl}/40x40/${rec.createUserLogo}`">
            <img :src="`${$ssoUrl}/images/user/logo.png`" />
          </el-avatar>
          <div class="info">
            <div class="name-state">
              <span class="cust-name">{{ rec.createUserName }}</span>
              <span class="type-name">{{ rec.contactTypeName }}</span>
            </div>
            <div class="time">{{ rec.creationTime }}</div>
            <div class="remark">{{ rec.followupContent }}</div>
            <div class="linkman" v-if="rec.linkName">联系人：{{ rec.linkName }}</div>
            <div class="pics" v-if="rec.attachList.length">
              <span>图片：</span>
              <el-image
                class="pic"
                v-for="(pic, index) in rec.attachList"
                :key="pic.fileGuid"
                :src="`${$fileBaseUrl}100x100/${pic.filePath}`"
                :preview-src-list="rec.viewPics"
                @click="viewPic(rec, index)"
              ></el-image>
            </div>
            <div class="linkman" v-if="rec.location">跟进地址：{{ rec.location }}</div>
            <div class="next-wrap" v-if="rec.nextFollowupDate">
              <span class="el-icon-time"></span>
              <span class="next-time">下次联系时间：{{ rec.nextFollowupDate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="records.length === 0"></div>
    </div>
    <pagination :total="total" :pageIndex="pageIndex" :pageSize="pageSize" :sizeChange="sizeChange" :currentChange="currentChange" />
  </div>
</template>

<script>
import { ContractApis, CustomerApis, DictionaryApis } from "@/apis";
import { DictionaryKey } from "@/utils/enum";
import Pagination from "@/components/pagination.vue";

export default {
  name: "detail-follow",
  props: {
    contract: { type: Object },
  },
  data() {
    return {
      user: {},
      contractId: this.$route.query.id,
      rules: {
        followupContent: [{ required: true, message: "请输入跟进内容", trigger: "change" }],
      },
      linkId: "",
      contactTypeId: "",
      nextFollowupDate: "",
      form: {
        followupContent: "",
      },
      contactTypeOptions: [],
      records: [],
      linkUserList: null,
      pageSize: 20,
      pageIndex: 1,
      total: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      DictionaryApis.getDictValueByKey(DictionaryKey.FollowWay).then((res) => {
        this.contactTypeOptions = res;
      });
      this.getFollowLogs();
      this.user = this.$store.state.user;
    },
    getFollowLogs() {
      ContractApis.getContFollowLogs(this.contractId, this.pageIndex, this.pageSize).then((res) => {
        this.records = res.data.map((i) => {
          i.location = (i.province || "") + (i.city || "") + (i.district || "") + (i.address || "");
          i.viewPics = i.attachList.map((p) => `${this.$fileBaseUrl}0x0/${p.filePath}`);
          const time = i.creationTime;
          if (time) {
            i.day = time.slice(8, 10);
            i.date = time.slice(0, 7);
          }
          return i;
        });
        this.total = res.dataCount;
      });
    },
    currentChange(page) {
      this.pageIndex = page;
      this.getFollowLogs();
    },
    sizeChange(size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.getFollowLogs();
    },
    // 联系人
    visibleLinks(boolean) {
      if (boolean && !this.linkUserList) {
        CustomerApis.getLinksByCustId(this.contract.customerId).then((res) => {
          this.linkUserList = res;
        });
      }
    },
    async addFollowLog() {
      await this.$refs.ruleFormRef.validate();
      const linkName = this.linkId ? this.linkUserList.find((l) => l.id === this.linkId).linkName : "";
      const contactTypeName = this.contactTypeId ? this.contactTypeOptions.find((c) => c.id === this.contactTypeId).description : "";
      const params = {
        id: 0,
        contractId: this.contractId,
        contractName: this.contract.contractName,
        customerId: this.contract.customerId,
        linkId: this.linkId,
        linkName,
        contactTypeId: this.contactTypeId,
        contactTypeName,
        nextFollowupDate: this.nextFollowupDate,
        followupContent: this.form.followupContent,
      };
      ContractApis.addContFollowLog(params).then((res) => {
        this.$message.success("合同记录保存成功");
        this.linkId = "";
        this.linkName = "";
        this.contactTypeId = "";
        this.contactTypeName = "";
        this.nextFollowupDate = "";
        this.$refs.ruleFormRef.resetFields();
        this.$emit("saveFollow");
        this.getFollowLogs();
      });
    },
    viewPic(rec, index) {
      const pics = rec.attachList.map((p) => `${this.$fileBaseUrl}0x0/${p.filePath}`);
      const prePics = pics.splice(index);
      const aftPics = pics.splice(0, index);
      rec.viewPics = prePics.concat(aftPics);
    },
  },
  components: { Pagination },
};
</script>

<style scoped lang="scss">
.detail-follow {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.follow-input {
  display: flex;
  .input-follow {
    margin-left: 24px;
    padding: 16px 15px 0;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    flex: 1;
    margin-bottom: 10px;
  }
  .operation {
    padding-bottom: 10px;
  }
  .label {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .type {
    width: 150px;
    margin-right: 24px;
    margin-bottom: 10px;
  }
  .date-time {
    width: 190px;
    margin-bottom: 10px;
  }
  .submit-btn {
    float: right;
    margin-bottom: 10px;
  }
}

::v-deep {
  .el-input__inner,
  .el-textarea__inner {
    border-color: #fff;
    background-color: #f6f7fc;
  }
  .el-textarea__inner {
    padding: 16px;
  }
}

.follow-list {
  flex: 1;
  padding-left: 86px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.follow-wrap {
  flex: 1;
  overflow: auto;
}
.follow-item {
  display: flex;
  padding: 15px 0;
  font-size: 14px;
  border-bottom: 1px solid #e9e9e9;

  .date-wrap {
    padding-right: 24px;
    text-align: center;
    color: #666;
    .day {
      font-size: 20px;
      line-height: 1.2;
    }
    .date {
      font-size: 12px;
    }
  }
  .pics {
    display: flex;
    margin: 4px 0;
    .pic {
      width: 100px;
      height: 100px;
      margin-left: 10px;
      border: 1px solid #e8e8e8;
      cursor: pointer;
      border-radius: 4px;
    }
  }
  .info {
    flex: 1;
    padding-left: 10px;
    line-height: 1.8;
    .name-state {
      display: flex;
      align-items: center;
    }
    .cust-name {
      color: #333;
      font-weight: bold;
    }
    .type-name {
      color: #2c68ff;
      background-color: #e4f0ff;
      font-size: 12px;
      padding: 0 6px;
      border-radius: 2px;
      margin-left: 12px;
    }
    .type-name {
      background-color: #dbfbdf;
      color: #2ba855;
    }
    .time {
      font-size: 12px;
      color: #666666;
    }
    .remark {
      color: #000;
      font-weight: bold;
      line-height: 1.5;
      margin: 5px 0;
    }
    .next-time {
      font-size: 13px;
      color: #333333;
      margin-left: 6px;
    }
  }
}
</style>
